import axios from "../config/axios";
import { useQuery } from "react-query";

// [10]
const getPersonsByName = async(name:string) => {
  const res = await axios.GENERAL.post("/persons/by_person_name", {"person_name":'%'+name.replaceAll('*','%')+'%'})
  if (res.status === 200) {
    console.log("getPersonsByName", res);
    return res.data
  }
}
// [10-1]
const getPersonLastnameByLanguage = async(lang:string) => {
  const res = await axios.GENERAL.get("/person_lastnames/"+lang)
  if (res.status === 200) {
    console.log("getPersonLastnameByLanguage", res);
    return res.data
  }

}
// [10-2]
const getPersonsByLastname = async(lastname:string) => {
  const res = await axios.GENERAL.get("/persons/by_person_lastname/"+lastname)
  if (res.status === 200) {
    console.log("getPersonsByLastname", res);
    return res.data
  }
}
// [10-3]
const getPersonById = async(person_id:string) => {
    const res = await axios.GENERAL.get("/person/info/"+person_id)
    if (res.status === 200) {
        console.log("getPersonByPersonId", res);
        return res.data
    }
}
// [10-4]
const getPersonsByIds = async(person_ids:string[]) => {
    const res = await axios.GENERAL.post("/persons/by_person_ids", {"person_ids":person_ids})
    if (res.status === 200) {
        console.log("getPersonsByPersonIds", res);
        return res.data
    }
}

export default {
  getPersonsByName,
  getPersonLastnameByLanguage,
  getPersonsByLastname,
  getPersonById,
    getPersonsByIds
};